<template>
	<div class="center-container">
		<h1>Forgot your password?</h1>
		<p>Enter your email below and we will send you a verification link to reset your password.</p> 
		
		<form @submit.prevent="onSend">
			<div class="login-container-alt">
				<label for="email">Email address</label>
				<input  placeholder="you@email.com" type="email" name="email" v-model="email" required>
				<button id="send-btn" type="submit">Send</button>
			</div>
		</form>
		
		<br>
		<p :style="{ opacity: 0.5 }">***<br>Please note that you can only reset your password once per 24-hours. If you are having trouble or have forgotten the email associated with your account, please contact us at <a href="mailto:support@bookplate.co">support@bookplate.co</a>.</p>
	</div>
</template>
<script>
	export default 
	{
		created () 
		{
			document.title = "Support | Bookplate";
			try
			{
				var login = document.getElementById("login-widget");
				login.className = "";
			}
			catch(e)
			{ 
				//pass
			}
		},
		methods:
		{
			async onSend()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}
				
				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					body: JSON.stringify({
						"email": this.email
					}),
					credentials: 'include',
					method: "POST"
				};

				let vue = this;

				fetch("https://api.bookplate.co/forgot-password", data)
				.then(function(response)
				{
					if(response.status == 404)
					{
						vue.$alert("No one with that email exists in our database. Please try a diffrent email address, or contact support@bookplate.co.", "Invalid email");
					}
					else if(response.status == 401)
					{
						vue.$alert("Sorry, you cannot reset your password more than once per 24-hours. Try again later or contact support@bookplate.co.", "Too many requests");
					}
					else
					{
						document.getElementById("send-btn").innerHTML = "Sent";
						document.getElementById("send-btn").className = "disabled";
						vue.$alert("A link to reset your password has been emailed to you.","Sent!");
					}
				})
			}
		}
	}
</script>